const moment = require("moment");

export function checkStatusExpiry(time1) {
  const currentTime = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS");

  const givenTime = moment(time1);
  const timeDifferenceInSeconds = moment(currentTime).diff(
    givenTime,
    "seconds"
  );

  return timeDifferenceInSeconds > 60;
}
